var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8MagneticCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.08,14.08) scale(0.89,0.89)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41,9h-34c-2.206,0 -4,1.794 -4,4v22c0,2.206 1.794,4 4,4h34c2.206,0 4,-1.794 4,-4v-22c0,-2.206 -1.794,-4 -4,-4z",
    fill: "#8fcae6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,22h-36c-0.553,0 -1,-0.448 -1,-1c0,-0.552 0.447,-1 1,-1h36c0.553,0 1,0.448 1,1c0,0.552 -0.447,1 -1,1z",
    fill: "#324561"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,17h-36c-0.553,0 -1,-0.448 -1,-1c0,-0.552 0.447,-1 1,-1h36c0.553,0 1,0.448 1,1c0,0.552 -0.447,1 -1,1z",
    fill: "#324561"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,34h-8c-0.553,0 -1,-0.448 -1,-1c0,-0.552 0.447,-1 1,-1h8c0.553,0 1,0.448 1,1c0,0.552 -0.447,1 -1,1z",
    fill: "#324561"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8MagneticCard);
export default __webpack_public_path__ + "static/media/icons8-magnetic-card.62ff39a1e4cf634993d1a31c2c314897.svg";
export { ForwardRef as ReactComponent };